module.exports = __webpack_public_path__ + "img/btn_menu_prefecture_c.301f7b46.png";